// client.js
// Action Creators for List operations

/****************************************************************
 * Actions
 ****************************************************************/
// Available Actions
export const CLIENT_ADD    = 'CLIENT_ADD';
export const CLIENT_REMOVE = 'CLIENT_REMOVE';
export const CLIENT_RENAME = 'CLIENT_RENAME';


/****************************************************************
 * Action Creators
 ****************************************************************/
// Adds a new client with the given name
export function addClient (name) {
  return {
    type: CLIENT_ADD,
    name,
  }
}

// Removes a client with the given id
export function removeClient (id) {
  return {
    type: CLIENT_REMOVE,
    id,
  }
}

// Renames the client with the given id to 'name'
export function renameClient (id, name) {
  return {
    type: CLIENT_RENAME,
    id,
    name,
  }
}



// WEBPACK FOOTER //
// ./src/actions/client.js